
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SimulationMap from './SimulationMap.vue';
import { GeneticsMapGroup, GeneticsMap } from '@/services/crossbreeding-service/models';

@Component({
  components: { SimulationMap }
})
export default class SimulationMapGroupBrowser extends Vue {
  @Prop({ type: Object }) readonly group: GeneticsMapGroup | null;
  @Prop({ type: Object }) readonly group2: GeneticsMapGroup | null;
  @Prop({ type: Object }) readonly highlightedMap: GeneticsMap | null;
  @Prop({ type: Boolean }) readonly enableMapSelection: boolean;
  @Prop({ type: Boolean }) readonly enableComposingSaplingsSelection: boolean;

  @Watch('group')
  onGroupPropertyChanged(value: GeneticsMapGroup | null) {
    if (value) {
      this.applyOverflow = false;
      this.visibleGroup = value;
      this.animationClass = 'group--animate-slide-right';
      this.onNextTickRerender(() => {
        this.isVisible = true;
        this.animationClass = 'group--animate-from-right';
        setTimeout(() => {
          this.applyOverflow = true;
        }, 350);
      });
    } else {
      this.isVisible = false;
      this.animationClass = 'group--animate-slide-right';
      this.applyOverflow = false;
      setTimeout(() => {
        this.visibleGroup = null;
      }, 350);
    }
  }

  @Watch('group2')
  onGroup2PropertyChanged(value: GeneticsMapGroup | null) {
    if (value) {
      this.animationClass = 'group--animate-slide-left';
      (this.$refs.scrollContainer as HTMLElement).scrollLeft = 0;
      this.applyOverflow = false;
      setTimeout(() => {
        this.visibleGroup = value;
        this.animationClass = 'group--animate-slide-right';
        this.onNextTickRerender(() => {
          this.animationClass = 'group--animate-from-right';
          setTimeout(() => {
            this.applyOverflow = true;
          }, 350);
        });
      }, 350);
    } else {
      this.animationClass = 'group--animate-slide-right';
      this.applyOverflow = false;
      setTimeout(() => {
        this.visibleGroup = this.group;
        this.animationClass = 'group--animate-slide-left';
        this.onNextTickRerender(() => {
          this.animationClass = 'group--animate-from-left';
          setTimeout(() => {
            this.applyOverflow = true;
          }, 350);
        });
      }, 350);
    }
  }

  visibleGroup: GeneticsMapGroup | null = null;
  animationClass: string | null = null;
  isVisible = false;
  applyOverflow = false;

  mapVariantLabel(index: number): string {
    if (index === 0) return String(this.$t('browser.optionBest'));
    return String(this.$t('browser.optionAlt', { n: index + 1 }));
  }

  handleMapClick(map: GeneticsMap) {
    setTimeout(() => {
      this.$emit('map-selected', map);
    }, 200);
  }

  handleComposingSaplingSelectedEvent(group: GeneticsMapGroup) {
    this.$emit('composing-sapling-selected', group);
  }

  handleOverlayClick() {
    this.$emit('leave-group-browsing');
  }
}
